import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// À mettre tout en bas de ton src/index.js (CRM)
// À mettre tout en bas de ton src/index.js
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      // ON DÉSIMPLANTE AU LIEU DE METTRE À JOUR
      registration.unregister().then(() => {
        console.log("Service Worker supprimé avec succès.");
      });
    }
  });
}